
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import './LandingPage.css';
import supabase from '../utils/supabaseClient';

const Waitlist = () => {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const onSubmit = async (data) => {
    setMessage('');
    setIsError(false);

    try {
      if (!supabase) {
        throw new Error('Supabase client is not initialized.');
      }

      const { error } = await supabase
        .from('waitlist')
        .insert([{ email: data.email }]);

      if (error) {
        if (error.code === '23505') { // Unique constraint violation (duplicate email)
          setIsError(false);
          setMessage(`You're already on the waitlist!`);
        } else {
          setIsError(true);
          setMessage(`Error joining waitlist: ${error.message}`);
        }
      } else {
        setIsError(false);
        setMessage(`Thanks for joining the waitlist! We'll keep you updated.`);
        reset(); // Clear the form
      }
    } catch (err) {
      setMessage(`An unexpected error occurred: ${err.message}`);
      setIsError(true);
    }
  };

  return (
    <div className="waitlist-container" id="waitlist">
      <h2>Join the Waitlist</h2>
      <p>Get early access to Keisha AI's platform - whether you're an enterprise, university, student, or individual interested in AI ethics and counter-racist education.</p>
      <form onSubmit={handleSubmit(onSubmit)} className="waitlist-form">
        <input
          type="email"
          placeholder="Enter your email"
          {...register('email', { required: true, pattern: /^\S+@\S+$/i })}
          disabled={isSubmitting}
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Joining...' : 'Join Waitlist'}
        </button>
      </form>
      {errors.email && <p className="error-message">A valid email is required.</p>}
      {message && (
        <p className={`form-message ${isError ? 'error-message' : 'success-message'}`}>
          {message}
        </p>
      )}
      <div className="enterprise-note">
        <p><strong>Available For:</strong> Enterprises • Universities • Students • Researchers • Individual Learners</p>
      </div>
    </div>
  );
};

export default Waitlist;
